import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EducationConflict extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Conflict Free Diamonds';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='EducationConflict'>
      <div className='ecTopBr'></div>
      <div className='ecBody'>
        <div className={'ecTr ecTr1'}>
          <div className={'ecTd tdMobile'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/conflict/topimg_m.png' />
          </div>
          <div className={'ecTd'}>
            <div className='ecTitle'>CONFLICT FREE DIAMONDS AND THE KIMBERLEY PROCESS</div>
            <div className='ecP'>At Diamonds Direct, we are proud to say our diamonds originate from a conflict free source. We can confidently stand behind this promise to you, not only because we are involved in the entire diamond manufacturing process; from the mine, to the cutting and polishing, to delivering the stone to the customer, but also because of an industry wide practice called The Kimberley Process Certification Scheme.</div>
            <div className='ecP'>The Kimberley Process is an international system established in 2003 to monitor the trade of rough diamonds. Spearheaded by the United Nations, this process ensures money generated from diamond trading and manufacturing does not finance unethical working environments, war, and anti-government or rebellious movements.</div>
          </div>
          <div className={'ecTd tdDesktop'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/conflict/topimg.png' />
          </div>
        </div>
        <div className={'ecTr ecTr2'}>
          <div className={'ecTd tdDesktop'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/conflict/conflictfree.png' />
          </div>
          <div className={'ecTd tdMobile'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/conflict/conflictfree_m.png' />
          </div>
          <div className='ecTd'>
            <div className='ecP'>The Kimberley Process restricts diamond importing and exporting to member countries. All diamond shipments crossing international borders are sent in a tamper resistant container with a government validated Kimberley Process Certificate. All certificates are resistant to forgery and numbered uniquely to match each shipment.</div>
            <div className='ecP'>Ultimately, The Kimberley Process prevents "blood diamonds" from entering the mainstream diamond markets and protects the consumer from purchasing an unethical diamond. The photos seen here demonstrate diamond shipments coming in and out of Diamonds Direct’s manufacturing facility in Tel Aviv, Israel. Each is clearly marked with The Kimberley Process seal.</div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default EducationConflict;

function mapStateToProps(state) {
  return {

  };
}

export const EducationConflictContainer = connect(
  mapStateToProps,
  allActionCreators
)(EducationConflict);


// WEBPACK FOOTER //
// ./src/components/views/education/EducationConflict.jsx